import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, MousePointerClick, GraduationCap, ArrowRight } from 'lucide-react';
const steps = [{
  n: 1,
  Icon: FolderOpen,
  title: 'Abrís el material',
  desc: 'Accedés a una plataforma simple, organizada por tomos y temas. Todo a un clic.'
}, {
  n: 2,
  Icon: MousePointerClick,
  title: 'Elegís una actividad',
  desc: 'Encontrás la propuesta justa para tu curso. Con objetivos, consigna y evaluación incluidas.'
}, {
  n: 3,
  Icon: GraduationCap,
  title: 'La aplicás en clase',
  desc: 'Imprimís, proyectás o compartís. Sin horas de planificación. Sin improvisar.'
}];
export function Solution() {
  return <section className="py-20 lg:py-24 bg-ink-900 text-white relative overflow-hidden" data-id="element-170">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-brand-500/20 rounded-full blur-3xl pointer-events-none" data-id="element-171"></div>
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-brand-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-172"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-174">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/10 text-brand-400 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-500/20" data-id="element-175">
            La solución
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold mb-4 leading-tight tracking-tight" data-id="element-176">
            Por eso creamos{' '}
            <span className="text-brand-500" data-id="element-177">Mega Pack Artística Lista</span>
          </h2>
          <p className="text-lg text-ink-300" data-id="element-178">
            Un sistema simple, en 3 pasos. Sin teoría innecesaria. Sin vueltas.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-4 relative" data-id="element-179">
          {/* Connector line desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px border-t-2 border-dashed border-ink-700 z-0" data-id="element-180"></div>

          {steps.map((step, i) => {
          const Icon = step.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15
          }} className="relative bg-ink-800 rounded-3xl p-8 border border-ink-700 z-10" data-id="element-181">
                {/* Number badge */}
                <div className="w-14 h-14 rounded-2xl bg-brand-500 text-white font-black text-2xl flex items-center justify-center shadow-cta mb-6" data-id="element-182">
                  {step.n}
                </div>
                <div className="w-12 h-12 rounded-xl bg-ink-900 text-brand-400 flex items-center justify-center mb-5 border border-ink-700" data-id="element-183">
                  <Icon className="w-6 h-6" data-id="element-184" />
                </div>
                <h3 className="font-extrabold text-xl mb-3 leading-tight text-white" data-id="element-185">
                  {step.title}
                </h3>
                <p className="text-ink-300 leading-relaxed" data-id="element-186">{step.desc}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-187">
          <p className="text-ink-300 inline-flex items-center gap-2 text-lg" data-id="element-188">
            Así de simple. <ArrowRight className="w-5 h-5 text-brand-500" data-id="element-189" />
            <span className="font-bold text-white" data-id="element-190">
              Sin más horas robadas a tu vida.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}